import BaseObject from '../../../base/base_object';
import {USER_ACTIVITY_EVENTS_ALL, USER_ACTIVITY_EVENTS_FOR_HYBRID } from '../../../events/events';
import Event from '../../../utils/event';
import {TimeSpan} from "@sparkware/app-utils";
import UserScrollDetector from './user_scroll_detector';
import Store from '../../../utils/store';
import { TOKEN_PROPERTIES } from '../oauth_const';
import Device from '../../../utils/device/device';

export default class UserActivityDetector extends BaseObject {
    static CLASS = 'UserActivityDetector';

    _now = () => Date.now();
    _userScrollDetector = null;
    _userActivityDetectionInterval = TimeSpan.fromMinutes(1);
    _serviceFactory = null;
    _onUserActivityCallback = () => { };

    /**
     *
     * @param params = {
     *  now: function,
     *  userScrollDetector: function
     * }
     */
    init(params) {
        super.init(params);

        params = Object.assign({}, params);

        this._now = params.now || this._now;
        this._userActivityDetectionInterval = params.userActivityDetectionInterval || this._userActivityDetectionInterval;
        this._onUserActivityCallback = params.onUserActivityCallback || this._onUserActivityCallback;
        this._serviceFactory = params.serviceFactory;

        this._userScrollDetector = params.userScrollDetector || UserScrollDetector.create({
            now: this._now,
            scrollCheckingInterval: this._userActivityDetectionInterval
        });
        this._userScrollDetector.setOnScrollCallback(this.setLastTimeUserPerformedAction.bind(this));

        this.setLastTimeUserPerformedAction();
        this._subscribe();
        this._startUserActivityDetectionTimer();
    }

    _userActivityEventsSubscription = null;
    _subscribe() {
        const userActivityEvents = Device.hybrid.isHybrid ? USER_ACTIVITY_EVENTS_FOR_HYBRID : USER_ACTIVITY_EVENTS_ALL;
        this._userActivityEventsSubscription = Event.on(userActivityEvents, this.setLastTimeUserPerformedAction, this);
    }

    _unSubscribe() {
        if (this._userActivityEventsSubscription) {
            this._userActivityEventsSubscription.off();
        }
    }

    setLastTimeUserPerformedAction() {
        // we store it into the local storage so different browser instances to share it
        Store.set(TOKEN_PROPERTIES.OAUTH_LAST_TIME_ACTIVITY, this._now());
    }


    getLastTimeUserPerformedAction() {
        return parseInt(Store.get(TOKEN_PROPERTIES.OAUTH_LAST_TIME_ACTIVITY, 0));
    }

    getTimeSinceLastUserActivity() {
        return this._now() - this.getLastTimeUserPerformedAction();
    }

    getUserActivityDetectionInterval() {
        return this._userActivityDetectionInterval.totalMilliseconds;
    }

    _userActivityDetectionTimer = {
        dispose: () => { }
    };


    _startUserActivityDetectionTimer() {
        this._userActivityDetectionTimer = this._serviceFactory.observableFactoryService().fromInterval(this._userActivityDetectionInterval.totalMilliseconds)
            .forEach(() => {
                let lastTimeUserPerformedAction = this.getLastTimeUserPerformedAction();
                let userActivityDetectionInterval = this.getUserActivityDetectionInterval();
                let now = this._now();

                if (lastTimeUserPerformedAction + userActivityDetectionInterval > now) {
                    this._onUserActivityCallback();
                }
            });
    }

    dispose() {
        this._userActivityDetectionTimer.dispose();
        this._userScrollDetector.dispose();
        this._unSubscribe();
    }
}
